import {DrupalNode} from "next-drupal";
import {Body} from "@/components/atoms/body";
import {Divider} from "@/components/atoms/divider";
import {Button} from "@/components/atoms/button";
import {Link} from "@/components/atoms/link";
import dynamic from "next/dynamic";
import {FormattedText} from "@/components/formatted-text";
import {useContext} from "react";
import {Dictionary} from "@/types/hygiena-types";
import {DictionaryContext} from "@/context/dictionary-context";
const DefinitionCard = dynamic(() => import("@/components/templates/paragraphs/paragraph--definition-card").then(mod => mod.DefinitionCard));

const ArticleSlider = dynamic(() => import("../../../organisms/slider").then((mod) => mod.ArticleSlider));

/**
 * The Article content output for Articles, this component should be loaded in using dynamic().
 * @param node
 * @constructor
 */
export function ContentArticleBody({ node }: {node: DrupalNode}) {
  const hasAISummary = node?.field_ai_summary_title?.value?.length
    && node?.field_ai_summary_description?.value?.length;
  return (
    <>
      {node.body?.processed && (
        <div className="container mx-auto px-6 lg:px-0">
          {hasAISummary && (
            <div className="pb-12">
              <DefinitionCard title={node.field_ai_summary_title.value} definition={node.field_ai_summary_description.value} />
            </div>
          )}
          <Body className="prose" bodyType="lg">
            <FormattedText processed={node.body.processed} />
          </Body>
        </div>
      )}
    </>
  )
}

/**
 * The Article content output for Articles, this component should be loaded in using dynamic().
 *
 * @param node
 *   The article node.
 * @param additionalContent
 *   Additional content object.
 * @param props
 * @constructor
 */
export function ContentArticleLower({ node, additionalContent, ...props }: {
  node: DrupalNode,
  additionalContent: object,
}) {
  const t = useContext<Dictionary>(DictionaryContext);

  return (
    <>
      {node?.type === "node--article" && <Divider/>}
      <div className="container mx-auto px-6 lg:px-0">
        {node?.type === "node--article" && (
          <Button href={"/news"} color="black" hover={{color: "black"}} invertColor={"black"} invert={true} className="!border-gray-300" icon="arrow-right">{`${t?.all?.back_to_news}`}</Button>
        )}
      </div>
      {additionalContent?.["relatedNews"]?.length ? (
        <div className="container px-6 py-24 mx-auto">
          <div className={"mb-6"}>
            <h2 className="mb-2 md:!text-4xl inline !text-gray-800 !font-semibold">
              {`${t?.all?.related_news}`}
            </h2>
            {/* @todo localize and fix this link */}
            <Link href={"/news"} className="max-md:block text-primary inline md:pl-6">{`${t?.all?.see_all_news}`}<span>&#8594;</span></Link>
          </div>
          <ArticleSlider articles={additionalContent?.["relatedNews"]}/>
        </div>
      ) : <></>}
    </>
  )
}
